
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isMobile } from '@/utils/tool';

@Component
export default class Footer extends Vue {
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;

  public isMobile = isMobile();
}
